/**
 * "Retrimite email" on a lead (19.10.2026): the email the site's form sent —
 * the brochure or the receipt of a contact request. Leads from a webinar or
 * from an expired enrolment never got one, so there is nothing to resend.
 */
export const NO_WELCOME_SOURCES = ["webinar", "inscriere_neplatita"];

export function canResendWelcome(lead) {
  return Boolean(lead) && !lead.deleted_at && !NO_WELCOME_SOURCES.includes(lead.source);
}

export function welcomeTitle(lead) {
  return lead?.form_variant === "brochure"
    ? "Retrimite emailul cu broșura"
    : "Retrimite confirmarea cererii de contact";
}
